<template>
  <div>
    <my-breadcrumb :items="pagination"></my-breadcrumb>
    <div class="forum-container">
      <div class="aalign-end aspace-between">
        <router-link :to="$route.params.section ? '/class/'+$route.params.section+'/forum' : '/forum'">
          <h6>
            <fa-icon class="mr-1" icon="long-arrow-alt-left"></fa-icon> Back to
            All Discussion
          </h6>
        </router-link>
      </div>

      <div class="forum-content pd-22 mt-4">
        <div class="forum-discussion-container">
          <div class="discussions">
            <div class="discussion discussion--single">
              <div class="discussion__left">
                <img src="/img/avatars/user-avatar4.png" alt="avatar" />
              </div>

              <div class="discussion__right">
                <h3 class="mrb-0">{{ forum.title }}</h3>
                <div class="flex aalign-center">
                  <router-link to="#" class="discussion__username">
                    {{ forum.user_name }}
                  </router-link>
                  <div class="discussion__dot"></div>
                  <span class="discussion__time">
                    {{ $helpers.formatDateTimeID(forum.created_at) }}
                  </span>
                </div>

                <p class="mt-2">
                  <div 
                    v-if="forum.is_latex"
                    v-katex="{expression: forum.content ? forum.content : ' ', 
                    options: { macros: {' ': '\\space '} }}"
                  ></div>
                  <div v-else v-html="forum.content"></div>
                </p>

                <p class="forum_p mt-2" v-if="forum.images.length > 0">
                  <img class="mr-2" width="100" :src="itm.url" v-for="(itm, idx) in forum.images">
                </p>

                <p class="forum_p mt-2" v-if="forum.files.length > 0">
                  <span v-for="(itm, idx) in forum.files"> 
                    <a :href="itm.url" target="_blank">{{itm.filename}}</a>
                    <br>
                  </span>
                </p>
              </div>
            </div>

            <div class="aspace-between aalign-center add-comment">
              <div class="discussion__comments-count">
                {{ forum.comments }} Comments
              </div>
              <my-button type="teal" @click="showReplyForm = !showReplyForm">
                <fa-icon icon="pencil-alt" class="mr-1"></fa-icon> Tulis Jawaban
                Kamu
              </my-button>
            </div>

            <div class="reply-form" v-if="showReplyForm">
              <b-textarea
                id="answer"
                rows="4"
                placeholder="Type your answer...." 
                v-model="newReply.content"
              ></b-textarea>

              <b-form-group label="Gunakan Latex" class="mt-4">
                <b-form-checkbox v-model="newReply.is_latex" name="check-button" switch>
                  <b>{{ newReply.is_latex ? 'Iya' : 'Tidak' }}</b>
                </b-form-checkbox>
              </b-form-group>

              <math-and-symbol
                v-model="newReply.latexCode"
                @add="addLatex($event)" 
                @batal="newReply.is_latex = false" 
                v-if="newReply.is_latex"
              ></math-and-symbol>

              <!-- <button class="e-button e-button--outline-black mt-4">
                <fa-icon icon="upload" class="mr-1"></fa-icon>
                Upload File/ Image
              </button> -->
              <br/>

              <p class="text-right mb-4">
                <my-button type="fill-blue" v-if="loading">
                  <b-spinner small label="Loading"></b-spinner>
                </my-button>
                <my-button type="fill-blue" @click="createReply" v-else>
                  Submit Jawabanmu
                  <fa-icon icon="paper-plane" class="ml-1"></fa-icon>
                </my-button>
              </p>
            </div>

            <div class="discussion discussion--reply text-center" style="display: block;" v-if="newCount > 0">
              <div class="discussion__comments-count" v-if="loadingNew">
                <b-spinner small label="Loading"></b-spinner>
              </div>
              <div class="discussion__comments-count" style="cursor: pointer;" v-else @click="loadNew">
                {{ newCount}} New Comment(s)
              </div>
            </div>

            <div class="reply-loading" v-if="!replyLoaded">
              <content-loader></content-loader>
            </div>

            <div class="discussion discussion--reply" v-for="(reply, i) in replies" :key="i" v-else>
              <div class="discussion__left">
                <img src="/img/avatars/user-avatar4.png" alt="avatar" />
              </div>

              <div class="discussion__right aflex-1">
                <div class="aspace-between aalign-start w-100">
                  <div>
                    <div class="flex aalign-center">
                      <router-link to="#" class="discussion__username">
                        {{ reply.user_name }}
                      </router-link>
                      <!-- <div class="discussion__dot"></div>
                      <router-link to="#" class="discussion__username">
                        <u> Hide this Reply </u>
                      </router-link> -->
                    </div>
                    <!-- <br /> -->
                    <span class="discussion__time">
                      {{ $helpers.formatDateTimeID(reply.created_at) }}
                    </span>
                  </div>

                  <!-- <div class="aalign-center">
                    <span :id="'tooltip-target-' + i">
                      <fa-icon icon="trash-alt" class="comment-action mt-2 mr-3 ml-3"></fa-icon>
                    </span>
                    <b-tooltip :target="'tooltip-target-' + i" triggers="hover">
                      Delete This Comment
                    </b-tooltip>

                    <span :id="'tooltip-target-r' + i">
                      <fa-icon icon="flag" class="comment-action mt-2"></fa-icon>
                    </span>
                    <b-tooltip :target="'tooltip-target-r' + i" triggers="hover">
                      Report
                    </b-tooltip>
                  </div> -->
                </div>

                <p class="mt-1">
                  <div v-if="reply.is_latex"  v-katex="{ 
                    expression: reply.content ? reply.content : ' ', 
                    options: { macros: {' ': '\\space '} }}">
                  </div>
                  <div v-else v-html="reply.content"></div>
                </p>
              </div>
            </div>
            <div class="text-center mt-4" v-if="loadMore">
              <my-button v-if="loadingMore">
                <b-spinner small label="Loading"></b-spinner>
              </my-button>
              <my-button @click="getReply" v-else>
                Load More
              </my-button>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters, mapActions } from "vuex";
import * as types from "@/store/types";
import { DB } from '@/helpers/fireinit';

export default {
  data() {
    return { 
      forum: {
        is_latex: false,
        title: null, 
        content: null, 
        user_name: null,
        createdAt: null, 
        comments: 0, 
        files: [], 
        images: []
      },
      replies: [],
      newReply: {
        content: "", 
        latexCode: ""
      },
      replyLoaded: false,
      showReplyForm: false,
      loading: false, 
      loadMore: false, 
      loadingMore: false, 
      loadingNew: false,
      added: false,
      newCount: 0,
      limit: 10, 
      offset: 0
    };
  },
  props: {
    collapsed: {
      default: false
    }
  },
  computed: {
    pagination() {
      var data = [
        {
          text: this.section.level,
          url: '#'
        },
        {
          text: this.section.class + " "+ this.section.major ? this.section.class : "",
          url: '#'
        },
        {
          text: this.section.subject,
          url: '#'
        },
        {
          text: this.section.curriculum,
          url: '#'
        },
        {
          text: this.section.chapter,
          url: '#'
        },{
          text: this.section.name,
          url: '#'
        }
      ]

      return data
    },
    ...mapGetters({
      isLoggedIn: types.IS_LOGGED_IN, 
      section: types.SECTION
    })
  },
  mounted() {
    if(this.isLoggedIn) {
      if(this.$route.params.section && this.$route.params.section != this.section.id) {
        this.$router.push('/class/' + this.$route.params.section)
      } else if(!this.$route.params.section && !this.section.id) {
        this.$router.push("/no-subject");
      } else {
        this.replyLoaded = false;

        this.getForum()
        this.getReply()

        var that = this
        var d = new Date()
        DB.ref('forum-reply/' + this.$route.params.id).off()
        DB.ref('forum-reply/' + this.$route.params.id).orderByChild("created_at")
        .startAt(d.toISOString()).on("child_added", function(snapshot) {
          var newForum = snapshot.val();
          that.newCount++
          that.newForumNotif()
        });
      }
    } else {
      var link = "/login"
      if(this.$route.params.section) {
        link += "?section=" + this.$route.params.section
      }
      this.$router.push(link);
    }
  },
  methods: {
    ...mapActions({
      forumReplyList: types.FORUM_REPLY_LIST,
      forumDetail: types.FORUM_DETAIL, 
      forumReply: types.FORUM_REPLY, 
      setOverlay: types.SET_OVERLAY
    }),
    newForumNotif() {
      if(this.added) {
        this.added = false;
      } else {
        this.$bvToast.toast('Ada jawaban baru', {
          title: 'New Reply',
          autoHideDelay: 3000, 
          toaster: 'b-toaster-top-right',
          variant: 'success'
        })
      }
    },
    getForum() {
      var payload = {
        params: {  
          id: this.$route.params.id
        }
      }

      this.forumDetail(payload)
      .then((response) => {
        this.forum = response
      })
      .catch((error) => {
        this.$bvToast.toast('Gagal memuat pertanyaan', {
          title: 'Success',
          autoHideDelay: 3000, 
          toaster: 'b-toaster-top-center',
          variant: 'danger'
        })
      });
    },
    loadNew() {
      this.offset = 0
      this.getForum()
      this.getReply()
    },
    getReply() {
      if(this.offset > 0) {
        this.loadingMore = true
      } else {
        this.loadingNew = true
      }
      var payload = {
        params: { 
          limit: this.limit, 
          offset: this.offset, 
          id: this.$route.params.id
        }
      }

      this.forumReplyList(payload)
      .then((response) => {
        this.loadingMore = false
        this.replyLoaded = true

        if(this.offset == 0) {
          this.newCount = 0;
          this.replies = []
          this.loadingNew = false
        }

        for (var i = 0; i < response.length; i++) {
          this.replies.push(response[i])
        }

        if(response.length < this.limit || this.replies.length == this.forum.comments) {
          this.loadMore = false
        } else {
          this.loadMore = true
        }

        this.offset = this.replies.length
      })
      .catch((error) => {
        this.loadingMore = false
        this.loadingNew = false
        this.replyLoaded = true
        this.$bvToast.toast('Gagal memuat daftar jawaban', {
          title: 'Success',
          autoHideDelay: 3000, 
          toaster: 'b-toaster-top-center',
          variant: 'danger'
        })
      });
    },
    createReply() {
      if(this.newReply.content) {
        this.loading = true
        this.added = true

        let newFormData = new FormData();
        newFormData.append("forum_id", this.$route.params.id);
        newFormData.append("content", this.newReply.content);
        newFormData.append("is_latex", this.newReply.is_latex ? 1 : 0);

        this.forumReply(newFormData)
        .then((response) => {
          this.loading = false
          this.showReplyForm = false
          this.$bvToast.toast('Jawaban berhasil disimpan', {
            title: 'Success',
            autoHideDelay: 3000, 
            toaster: 'b-toaster-top-center',
            variant: 'success'
          })

          this.offset = 0
          this.getForum()
          this.getReply()
        })
        .catch((error) => {
          this.loading = false
          this.added = false
          this.$bvToast.toast('Jawaban gagal disimpan', {
            title: 'Success',
            autoHideDelay: 3000, 
            toaster: 'b-toaster-top-center',
            variant: 'danger'
          })
        });
      } else {
        this.$bvToast.toast('Isi jawaban tidak boleh kosong', {
          title: 'Empty Data',
          autoHideDelay: 3000, 
          toaster: 'b-toaster-top-center',
          variant: 'warning'
        })
      }
    },
    addLatex(data) {
      this.newReply.content += data;
      this.newReply.latexCode = "";
    }
  }
};
</script>

<style>
.forum-container {
  padding: 27px;
}

.forum-content {
  padding: 24px 23.8px 43.5px 25.8px;
  background-color: #ffffff;
}

.forum_p {
  font-size: 12px;
}

#add-modal .modal-dialog {
  max-width: 936px;
}

.forum-discussion-container {
  width: 100%;
  max-width: 970px;
  margin-left: auto;
  margin-right: auto;
}
</style>
